import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { checkSavedCourseActions } from "../slices";

function* checkSavedCourseWorker({ payload }) {
  try {
    yield put(checkSavedCourseActions.pending());
    const response = yield call(courseAPI.checkSavedCourse, payload);
    if (response.data === true) {
      yield put(checkSavedCourseActions.markSaved());
    } else {
      yield put(checkSavedCourseActions.markUnsaved());
    }
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(checkSavedCourseActions.markUnsaved(error));
    // TODO: handle callback | onFailure
  }
}

export { checkSavedCourseWorker };
